// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__HYqth","title":"AfterFrontImage_title__2zFvc"};